import { basicEnum } from "./base";

export const ProvisionReturnStatusEnum = basicEnum([
    {
        label: "Menunggu",
        value: "W", // Waiting
    },
    {
        label: "Selesai",
        value: "D", // Done
    },
]);

export namespace ProvisionReturnStatusEnum {
    export type Labels = (typeof ProvisionReturnStatusEnum)["labels"][number];
    export type Values = (typeof ProvisionReturnStatusEnum)["values"][number];
}
